import React from 'react'
import { alpha } from '@mui/material/styles';
import { Button, FormControl, Grid, InputBase, InputLabel, Link, Paper, Stack, Step, StepButton, StepLabel, Stepper, styled, TextField, Typography, useMediaQuery } from '@mui/material'
import banner22 from '../assests/background-web.jpg';
import { useNavigate } from 'react-router-dom';
import SellingQuest from './Questioneries/SellingQuest';
import HouseOutlinedIcon from '@mui/icons-material/HouseOutlined';
import ApartmentOutlinedIcon from '@mui/icons-material/ApartmentOutlined';
import GiteOutlinedIcon from '@mui/icons-material/GiteOutlined';
import HomeWorkOutlinedIcon from '@mui/icons-material/HomeWorkOutlined';

const CustomBanner = styled(Paper)(({ theme }) => ({
    width: '100%',
    height: '100vh',
    background: 'linear-gradient(to right, #0135f999, #b966e787)',
    marginTop: '2em',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    background: ` linear-gradient(
        rgb(197 192 192 / 7%), 
        rgb(0 0 0 / 28%)
      ),url(${banner22})`,
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    borderRadius: '0px',
    overflow: 'hidden'
}))

const StyledBtn = styled(Button)(({ theme, Matches }) => ({
    width: Matches ? '100%' : '35%',
    color: '#fff',
    background: '#978A7D',
    borderRadius: '10px',
    fontSize: '16.5px',
    padding: '7px 8px',
    fontWeight: 400,
    transition: '0.15s',
    textTransform: "none",
    marginTop: '1em',
    '&:hover': {
        background: '#444444',
        color: '#fff',
    }
}))

const StyledBtn1 = styled(Button)(({ theme, isButtonDisabled }) => ({
    width: '35%',
    color: '#005624',
    backgroundColor: isButtonDisabled ? '#d7d7d7' : '#99cc33',
    borderRadius: '5px',
    fontSize: '14.5px',
    padding: '7px 8px',
    fontWeight: 700,
    transition: '0.15s',
    textTransform: "none",
    marginTop: '1em',
    '&:hover': {
        backgroundColor: isButtonDisabled ? '#d7d7d7' : '#99cc33',
        color: isButtonDisabled ? '#000' : '#fff',
        borderColor: isButtonDisabled ? '#d7d7d7' : '#99cc33'
    }
}))

const BootstrapInput = styled(InputBase)(({ theme }) => ({
    'label + &': {
        marginTop: theme.spacing(3),
    },
    '& .MuiInputBase-input': {
        borderRadius: 4,
        position: 'relative',
        backgroundColor: theme.palette.mode === 'light' ? '#F3F6F9' : '#1A2027',
        border: '1px solid',
        borderColor: theme.palette.mode === 'light' ? '#E0E3E7' : '#2D3843',
        fontSize: 16,
        width: '100%^',
        padding: '10px 12px',
        transition: theme.transitions.create([
            'border-color',
            'background-color',
            'box-shadow',
        ]),
        // Use the system font instead of the default Roboto font.
        fontFamily: [
            '-apple-system',
            'BlinkMacSystemFont',
            '"Segoe UI"',
            'Roboto',
            '"Helvetica Neue"',
            'Arial',
            'sans-serif',
            '"Apple Color Emoji"',
            '"Segoe UI Emoji"',
            '"Segoe UI Symbol"',
        ].join(','),
        '&:focus': {
            boxShadow: `${alpha(theme.palette.primary.main, 0.25)} 0 0 0 0.2rem`,
            borderColor: theme.palette.primary.main,
        },
    },
}));

const steps = [
    { label: 'Step 1', fields: ['address', 'unit'], fieldName: ['What is your street address?', 'If there is a unit number please specify:'], defaultValue: ['123 Street Rd', 'Unit Number(optional)'] },
    { label: 'Step 2', fields: ['options'], fieldName: ['When are you thinking about listing your home?'] },
    { label: 'Step 3', fields: ['options1'], fieldName: ['How many bedrooms?'] },
    { label: 'Step 4', fields: ['options2'], fieldName: ['How many bathrooms?'] },
    { label: 'Step 5', fields: ['optionswithinfo'], fieldName: [`Are you also planning to buy a home?`] },
    { label: 'Step 6', fields: ['firstName'], fieldName: ['First Name', 'Last Name'], defaultValue: ['First Name', 'Last Name'], },
    // Add more steps as needed
];

const optionsSets = {
    options: ['I want to list my home ASAP!', 'In 1-3 months', 'In 3-6 months', 'More than 6 months from now', "I've already listed my home with another agent"],
    options1: ['1 Bedroom', '2 Bedrooms', '3 Bedrooms', '4 Bedrooms', '5+ Bedrooms'],
    options2: ['1 Bathroom', '1.5 Bathrooms', '2+ Bathrooms', '3+ Bathrooms', '4+ Bathrooms'],
    optionswithinfo: ['Yes', 'No',],
};



const Buyingsteps = [
    { label: 'Step 1', fields: ['idealLocation'], fieldName: ['Where is your ideal location?'], defaultValue: ['Neighborhod/City, State, ZIP Code'] },
    { label: 'Step 2', fields: ['typeofhome'], fieldName: ['What type of home are you looking for?'] },
    { label: 'Step 3', fields: ['options1'], fieldName: ['How many bedrooms?'] },
    { label: 'Step 4', fields: ['options2'], fieldName: ['How many bathrooms?'] },
    { label: 'Step 5', fields: ['options3'], fieldName: ['What is your approximate price range?'] },
    { label: 'Step 6', fields: ['options4'], fieldName: ['When are you thinking about buying?'], },
    { label: 'Step 7', fields: ['options5'], fieldName: ['Are you currently working with an agent?'], },
    { label: 'Step 8', fields: ['options6'], fieldName: ['How would you best describe your home buying goals?'], },
    { label: 'Step 9', fields: ['optionswithmultiline'], fieldName: [`Are you interested in winning a bidding war by turning your offer into cash with Houwzer's Cash Advantage?`], },
    { label: 'Step 10', fields: ['options8'], fieldName: ['Are you also selling a home and interested in a seamless buy and sell experience?'], },
    { label: 'Step 11', fields: ['address', 'unit'], fieldName: ['What is your street address?', 'If there is a unit number please specify:'], defaultValue: ['123 Street Rd', 'Unit Number(optional)'] },
    { label: 'Step 12', fields: ['firstName'], fieldName: ['First Name', 'Last Name'], defaultValue: ['First Name', 'Last Name'], },
];

const BuyingoptionsSets = {
    typeofhome: [
        { value: 'Detached house', component: <Stack direction="column" display="flex" justifyContent="center" alignItems="center"><HouseOutlinedIcon sx={{ fontSize: 60, color: '#fff', '&:hover': { color: '#fff', } }} />Detached House</Stack> },
        { value: 'Townhome', component: <Stack direction="column" display="flex" justifyContent="center" alignItems="center"><ApartmentOutlinedIcon sx={{ fontSize: 60, color: '#fff', '&:hover': { color: '#fff', } }} />Townhome</Stack> },
        { value: 'Condominium', component: <Stack direction="column" display="flex" justifyContent="center" alignItems="center"><GiteOutlinedIcon sx={{ fontSize: 60, color: '#fff', '&:hover': { color: '#fff', } }} />Condominium</Stack> },
        { value: 'Multi-unit', component: <Stack direction="column" display="flex" justifyContent="center" alignItems="center"><HomeWorkOutlinedIcon sx={{ fontSize: 60, color: '#fff', '&:hover': { color: '#fff', } }} />Multi-unit</Stack> },
    ],
    options1: ['1 Bedroom', '2 Bedrooms', '3 Bedrooms', '4 Bedrooms', '5+ Bedrooms'],
    options2: ['1 Bathroom', '1.5 Bathrooms', '2+ Bathrooms', '3+ Bathrooms', '4+ Bathrooms'],
    options3: ['$0-$200k', '$200k +', '$400k +', '$800k +', '$1.5m +',],
    options4: ['I want to buy as soon as possible', 'In 1-3 months', 'In 3-6 months', 'More than 6 months from now',],
    options5: ['Yes', 'No'],
    options6: ['First-time buyer seeking my first home purchase', 'Current homeowner looking to upgrade to a larger/better home', 'Current homeowner seeking to downsize for simplicity', 'Investor looking to acquire additional properties', 'Interested in buying a vacation property',],
    optionswithmultiline: ['Yes', 'Maybe', 'No',],
    options8: ['Yes', 'No'],
};


const BuyingSellingsteps = [
    { label: 'Step 1', fields: ['address', 'unit'], fieldName: ['What is your street address?', 'If there is a unit number please specify:'], defaultValue: ['123 Street Rd', 'Unit Number(optional)'] },
    { label: 'Step 2', fields: ['options1'], fieldName: ['When are you thinking about listing your home?'], },
    { label: 'Step 3', fields: ['options2'], fieldName: ['How many bedrooms?'] },
    { label: 'Step 4', fields: ['options3'], fieldName: ['How many bathrooms?'] },
    { label: 'Step 5', fields: ['options4'], fieldName: ['How would you best describe your goals?'] },
    { label: 'Step 6', fields: ['options5'], fieldName: ['I want to....'], },
    { label: 'Step 8', fields: ['firstName'], fieldName: ['First Name', 'Last Name'], defaultValue: ['First Name', 'Last Name'], },
];

const BuyingSellingoptionsSets = {
    options1: ['I want to list my Home ASAP!', 'In 1-3 months', 'In 3-6 months', 'More than 6 months from now', `I've already listed my home with another agent`],
    options2: ['1 Bedroom', '2 Bedrooms', '3 Bedrooms', '4 Bedrooms', '5+ Bedrooms'],
    options3: ['1 Bathroom', '1.5 Bathrooms', '2+ Bathrooms', '3+ Bathrooms', '4+ Bathrooms'],
    options4: ['Current homeowner selling in order to upgrade to a larger/better home', 'Homeowner seeking to downsize to a smaller home for simplicity', 'Investor looking to buy and sell properties', 'Interested in selling and buying vacation properties',],
    options5: ['Sell my existing home first to maximize my profit', 'Buy my next home first to minimize my stress'],
};

const GetStarted = () => {
    const history = useNavigate();
    const [formData, setFormData] = React.useState({});
    const [activeStep, setActiveStep] = React.useState(0);
    const [error, setError] = React.useState('');
    const [selectedPhase, setSelectedPhase] = React.useState(null);
    const [showButtons, setShowButtons] = React.useState(true);
    const [question, setQuestion] = React.useState([]);
    const [currentQuestionIndex, setCurrentQuestionIndex] = React.useState(0);
    const [inputPresent, setInputPresent] = React.useState(false);
    const [activePhase, setActivePhase] = React.useState(null);
    const matches = useMediaQuery('(max-width:600px)');

    const handleSellingClick = () => {
        setActivePhase('selling');
        setShowButtons(false);
    };
    const handleBuyingClick = () => {
        setActivePhase('buying');
        setShowButtons(false);
    };
    const handleButtonsClick = () => {
        setActivePhase('sellingandbuying');
        setShowButtons(false);
    };



    return (
        <CustomBanner elevation={0}>
            <div style={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'start',
                alignItems: 'center',
                width: '100%',
                height: '100%',
                backgroundColor: '#978a7d73', /* Adjust the background color opacity */
                padding: '2em',
                textAlign: 'center',
                color: '#fff'
            }}>
                <Grid container spacing={2} display="flex"  justifyContent="start" alignItems="center" sx={{
                    mt: '1em',
                    maxHeight: '900px'
                }}>
                    {showButtons && (
                        <Grid item xs={12} display="flex" flexDirection="column" justifyContent="start" alignItems="center">
                            <Typography variant="h4" color="#fff"
                            sx={{
                                mb: '1em',
                                fontSize: matches ? '22px' : null,
                                fontWeight: matches ? 600 : null,
                                letterSpacing: '-0.03em',
                        }}>
                                Where do you want to start?
                            </Typography>
                            <StyledBtn variant="contained" onClick={handleSellingClick} Matches={matches}>
                                Selling a Home
                            </StyledBtn>
                            <StyledBtn variant="contained" onClick={handleBuyingClick} Matches={matches}>
                                Buying a Home
                            </StyledBtn>
                            <StyledBtn variant="contained" onClick={handleButtonsClick} Matches={matches}>
                                Buying and Selling
                            </StyledBtn>
                            {/* {phaseLabels.map((label, index) => (
                                <StyledBtn key={index} variant="contained" onClick={() => handlePhaseSelection(index)}>
                                    {label}
                                </StyledBtn>
                            ))} */}
                        </Grid>
                    )}

                </Grid>
                {<div>
                    {activePhase === 'selling' && (
                        <div>
                            <SellingQuest steps={steps} optionsSets={optionsSets} />
                        </div>
                    )}
                    {activePhase === 'buying' && (
                        <div>
                            <SellingQuest steps={Buyingsteps} optionsSets={BuyingoptionsSets} />
                        </div>
                    )}
                    {activePhase === 'sellingandbuying' && (
                        <div>
                            <SellingQuest steps={BuyingSellingsteps} optionsSets={BuyingSellingoptionsSets} />
                        </div>
                    )}
                </div>}
            </div>
        </CustomBanner>

    )
}

export default GetStarted